<template>
  <div class="color-picker">
    <div class="top">
      <h2>
        {{ title }}
      </h2>
      <div class="picker-wrap">
        <span> Select color </span>
        <input
          type="color"
          :value="color"
          @input="emitColor($event.target.value)"
        />
      </div>
    </div>
    <div class="bottom">
      {{ label }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    label: {
      type: String,
    },
    color: {
      type: String,
    },
    idx: {
      type: Number,
    },
  },
  methods: {
    emitColor(value) {
      this.$emit("emitColor", {
        value,
        idx: this.idx,
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.color-picker {
  margin: 25px 0 50px 0;
  .top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 25px 0;
    width: 450px;
    h2 {
      margin: 0;
      font-family: Roboto;
      font-style: normal;
      font-weight: 500;
      font-size: 18px;
      line-height: 21px;
      color: #001529;
      width: 200px;
    }
    .picker-wrap {
      border:1px solid #cbcbe4;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        // border: 1px solid #dfe1e6;
        height: 31px;
        border-radius: 2px 0px 0px 2px;
        padding: 1px 5px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 22px;
        color: #001529;
      }
      input {
        width: 38px;
        height: 38px;
        padding: 0;
        border-radius: 0;
        background: none;
        border: none;
        outline: none;
        cursor: pointer;
      }
    }
  }
  .bottom {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 16px;
    color: #001529;
  }
}
</style>